const Pieces = [
	{
		type: 'tour',
		color: 'black',
		xPion: 0,
		yPion: 0,
		isAlive: true,
	},
	{
		type: 'cavalier',
		color: 'black',
		xPion: 0,
		yPion: 1,
		isAlive: true,
	},
	{
		type: 'fou',
		color: 'black',
		xPion: 0,
		yPion: 2,
		isAlive: true,
	},
	{
		type: 'dame',
		color: 'black',
		xPion: 0,
		yPion: 3,
		isAlive: true,
	},
	{
		type: 'roi',
		color: 'black',
		xPion: 0,
		yPion: 4,
		isAlive: true,
	},
	{
		type: 'fou',
		color: 'black',
		xPion: 0,
		yPion: 5,
		isAlive: true,
	},
	{
		type: 'cavalier',
		color: 'black',
		xPion: 0,
		yPion: 6,
		isAlive: true,
	},
	{
		type: 'tour',
		color: 'black',
		xPion: 0,
		yPion: 7,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 0,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 1,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 2,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 3,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 4,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 5,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 6,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'black',
		xPion: 1,
		yPion: 7,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 0,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 1,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 2,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 3,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 4,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 5,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 6,
		isAlive: true,
	},
	{
		type: 'pion',
		color: 'white',
		xPion: 6,
		yPion: 7,
		isAlive: true,
	},
	{
		type: 'tour',
		color: 'white',
		xPion: 7,
		yPion: 0,
		isAlive: true,
	},
	{
		type: 'cavalier',
		color: 'white',
		xPion: 7,
		yPion: 1,
		isAlive: true,
	},
	{
		type: 'fou',
		color: 'white',
		xPion: 7,
		yPion: 2,
		isAlive: true,
	},
	{
		type: 'dame',
		color: 'white',
		xPion: 7,
		yPion: 3,
		isAlive: true,
	},
	{
		type: 'roi',
		color: 'white',
		xPion: 7,
		yPion: 4,
		isAlive: true,
	},
	{
		type: 'fou',
		color: 'white',
		xPion: 7,
		yPion: 5,
		isAlive: true,
	},
	{
		type: 'cavalier',
		color: 'white',
		xPion: 7,
		yPion: 6,
		isAlive: true,
	},
	{
		type: 'tour',
		color: 'white',
		xPion: 7,
		yPion: 7,
		isAlive: true,
	},
]

export default Pieces
